
































// Importing components
import BaseCard from '@/ui/BaseCard.vue';
import TheFormUsers from '@/components/users/TheFormUsers.vue';
import BaseLoadingAnimation from '@/ui/BaseLoadingAnimation.vue';
import LayoutApp from '@/layputs/LayoutApp.vue';
// Importing functions
import {validateUpdateUser} from '@/ts/users/validate-user';
import {putUser} from '@/ts/users/put-user';
import {getUser} from '@/ts/users/get-user';

export default {
    name: 'PageUsersUpdate',
    components: {
        LayoutApp,
        BaseCard,
        TheFormUsers,
        BaseLoadingAnimation,
    },
    props: {},
    data() {
        return {
            userData: {},
            items: [],
            errors: [],
        };
    },
    methods: {
        onSubmit() {
            this.errors = [];

            validateUpdateUser(this.errors, this.userData);

            if (this.errors.length === 0) {
                putUser(this.userData).then(() => {
                    this.$router.push({ path: '/users' });
                });
            }
        },
    },
    created() {
        // Initializing the items object
        this.items = [{
            text: 'Панел',
            to: { path: '/dashboard' },
        }, {
            text: 'Потребители',
            to: { path: '/users' },
        }, {
            text: 'Редактиране',
        }];
        // Initializing the user data object
        this.userData = {
            first_name: '', last_name: '', email: '',
            phone: '', password: '', password_confirmation: '',
            id: this.$route.params.id,
        };
        this.$store.dispatch('setLoadingOn');
        // Fetching data from the API
        getUser(this.$route.params.id).then((response) => {
            Object.assign(this.userData, response);
        }).finally(() => {
            this.$store.dispatch('setLoadingOff');
        });
    },
};
